const validate = (values:any) => {
  const errors: {
    caseTitle: string|undefined,
    notes: string|undefined,
    caseType: string|undefined,
    dueDate: string|undefined,
    lor: string|undefined,
  } = {
    caseTitle: undefined,
    notes: undefined,
    caseType: undefined,
    dueDate: undefined,
    lor: undefined
  }

  if (!values.caseTitle){
    errors.caseTitle="Title is required";
  }

  if (!values.notes){
    errors.notes="Required";
  }

  if (!values.caseType){
    errors.caseType="Required";
  }

  if (values?.caseType && !values?.lor) {
    errors.lor="Required";
  }

  if (!values.dueDate){
    errors.dueDate="Required";
  }
  
  return errors;
};

export default validate;